import type { AuthContextType } from "@/context/AuthContext";
import type { FormType } from "../../types";

type Props = {
	cancelSubscription: () => Promise<unknown | null>;
	setCancelLoader: (value: boolean) => void;
	setFormType: (value: FormType) => void;
	setSubscriptionWillCancel: (value: boolean) => void;
	context: AuthContextType | null;
};

export async function onCancelSubscription(props: Props) {
	const {
		cancelSubscription,
		setCancelLoader,
		setFormType,
		setSubscriptionWillCancel,
		context,
	} = props;

	setCancelLoader(true);

	if (!context?.isAuthenticated) {
		setCancelLoader(false);
		return;
	}

	try {
		await cancelSubscription();

		setSubscriptionWillCancel(true); // optimistic update
		setFormType("success");
	} finally {
		setCancelLoader(false);
	}
}

export type OnCancelSubscriptionType = typeof onCancelSubscription;
